<template>
  <div
    :class="[
      'inline-flex h-8 w-8 items-start justify-center rounded-md p-1 text-2xl',
      props.showAdd && emoji ? 'hover:bg-primary-50 cursor-pointer' : '',
      className,
      props.size === 'large' ? 'scale-[200%]' : '',
    ]"
    data-testid="t-emoji-display"
  >
    <div
      v-if="emoji?.imageUrl"
      :style="'background-image: url(' + emoji.imageUrl + ')'"
      class="h-4 w-4 bg-contain bg-center bg-no-repeat"
    />
    <div v-else-if="emoji?.native" class="text-base">
      {{ emoji.native }}
    </div>
    <div v-else-if="!props.showAdd" class="h-6 text-gray-400">
      <!--<TIcon name="article" class="h-6 w-6" />-->
    </div>

    <TButton v-else icon="add_photo" type="tonal" color="primary" dense />
  </div>
</template>
<script lang="ts" setup>
import TButton from '../Button/TButton.vue';
import { computed, type ComputedRef } from 'vue';
import { type Emoji, findEmoji } from './emojiIndex';

const props = defineProps<{
  emojiId?: string;
  showAdd?: boolean;
  className?: string | string[];
  size?: 'default' | 'large';
}>();

const emoji: ComputedRef<Emoji | null> = computed(() => {
  return findEmoji(props.emojiId);
});
</script>
